module.exports = __webpack_public_path__ + "media/images/malvinas/covid19-926487357c6d97b70610b6ff6165ccb2.svg";